import { bool, node, string } from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

import getInfoTooltip from './get-info-tooltip';

export default function getTooltipButtonWithText(helpTexts) {
  function TooltipButton({ helpKey, children, showTooltip, section, ...rest }) {
    return (
      <Button {...rest}>
        {children}
        {showTooltip && getInfoTooltip(helpTexts, helpKey, section)}
      </Button>
    );
  }

  TooltipButton.propTypes = {
    helpKey: string.isRequired,
    children: node.isRequired,
    disabled: bool,
    showTooltip: bool,
    section: string.isRequired,
  };

  TooltipButton.defaultProps = {
    disabled: false,
    showTooltip: true,
  };

  return TooltipButton;
}
